const typesMap = {
  base64: 'readAsDataURL',
  text: 'readAsText',
  binary: 'readAsBinaryString',
  buffer: 'readAsArrayBuffer',
};

/**
 * @param {Blob} file
 * @param {'base64'|'text'|'binary'|'buffer'} [as]
 * @returns {Promise<*>}
 */
const readFile = (file, as = 'base64') =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => resolve(reader.result));
    reader.addEventListener('error', (e) => reject(e));
    reader[typesMap[as]](file);
  });

const readFiles = (files, as) =>
  Promise.all(Array.from(files).map((file) => readFile(file, as)));

export default readFile;
export { readFiles };
